<template>
  <v-row justify="start">
    <v-dialog
      v-model="d_fr"
      persistent
      max-width="550px"
      scrollable
      @click:outside="$emit('close')"
      @keydown.esc="$emit('close')"
    >
      <v-card class="rounded_max hide_overflow" flat>
        <v-toolbar dense flat>
          <div class="d-flex align-center">
            <v-icon class="mr-1">mdi-text-box-check-outline</v-icon>
            <h3 class="mr-3">Final Report</h3>
            <p class="mb-0 mt-1 grey--text">{{ msg }}</p>
          </div>
          <v-spacer></v-spacer>
          <v-btn fab x-small depressed @click="$emit('close')"
            ><v-icon small>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text class="px-2 pb-0">
          <v-container style="height: max-content" v-if="inventory">
            <div class="mb-3" v-for="(item, i) in inventory.question" :key="i">
              <div
                class="my-2 d-flex"
                v-if="
                  i != 0 &&
                  inventory.question[i].category !==
                    inventory.question[i - 1].category
                "
              >
                <v-icon color="var(--g)">mdi-chevron-right</v-icon>
                <h3 class="color_default text-capitalize">
                  {{ item.category == "lainya" ? "Others" : item.category }}
                </h3>
              </div>
              <div class="my-2 d-flex" v-else-if="i == 0">
                <v-icon color="var(--g)">mdi-chevron-right</v-icon>
                <h3 class="color_default text-capitalize">
                  {{ item.category == "lainya" ? "Others" : item.category }}
                </h3>
              </div>

              <div class="d-flex align-start">
                <h4 class="mr-2">{{ item.no }}</h4>
                <div style="flex: 1">
                  <h4 v-html="item.question"></h4>
                  <p
                    class="default_txt"
                    v-if="item.additional"
                    v-html="item.additional"
                  ></p>
                  <v-textarea
                    class="my-2 rounded-lg"
                    auto-grow
                    outlined
                    :disabled="disabled"
                    rows="3"
                    :placeholder="disabled ? '' : 'Type here'"
                    color="green"
                    hide-details
                    v-model="item.answer"
                    @blur="saveAnswer(item.answer, item.id, inventory.id)"
                    dense
                  ></v-textarea>
                </div>
              </div>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed dark color="var(--g)" @click="$emit('close')"
            >Done</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {},
  computed: {
    ...mapState({
      role: (state) => state.role,
    }),
  },
  data() {
    return {
      loading: false,
      msg: "",
    };
  },
  name: "dialogFinalReport",
  props: ["d_fr", "type", "inventory", "disabled"],
  methods: {
    saveAnswer(answer, id, key_id) {
      this.loading = true;
      this.msg = "saving...";
      this.inventory.body[key_id] = id;
      this.inventory.body["answer"] = answer;
      let data = {
        path: this.inventory.path,
        body: this.inventory.body,
      };
      this.$store
        .dispatch("chat/postApi", data)
        .then((data) => {
          this.msg = "saved!";
          setTimeout(() => {
            this.msg = "";
          }, 1000);
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    closeAndFetch() {
      this.$emit("refetch");
      this.$emit("close");
    },
  },
};
</script>

<style></style>
